import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { selectCurrentUser } from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React from 'react';
import {
  EventScheduledEvent,
  PopupButton,
  useCalendlyEventListener,
} from 'react-calendly';
import { useSelector } from 'react-redux';
import styles from './BookDemoButton.module.css';
import { useBookDemo } from './use-book-demo';

export const BookDemoButton = ({
  button = 'Book a Demo',
  utm,
  className,
  show,
  calendlyUrl,
  onEventScheduled,
}: {
  utm?: string;
  button?: string;
  className?: string;
  show?: boolean;
  calendlyUrl?: string;
  onEventScheduled?: (e: EventScheduledEvent) => void;
}) => {
  const currentUser = useSelector(selectCurrentUser);
  const activeCompany = useSelector(activeCompanySelector);

  const { updateUserAttributes } = useUsersCRUDActions();
  const { isEligibleForDemo, rootElement, demoUrl } = useBookDemo(utm);
  const hiddenButton = !(show ? show : isEligibleForDemo);

  const updateAttributes = async () => {
    if (currentUser) {
      await updateUserAttributes(activeCompany?.id, currentUser.id, {
        requestedDemo: true,
      });
    }
  };

  useCalendlyEventListener({
    onEventScheduled: e =>
      onEventScheduled ? onEventScheduled(e) : updateAttributes(),
  });

  if (hiddenButton || !rootElement) {
    return null;
  }

  return (
    <PopupButton
      className={classNames(styles.button, className)}
      url={calendlyUrl || demoUrl}
      rootElement={rootElement}
      text={button}
      prefill={{
        email: currentUser?.email,
        name: currentUser
          ? `${currentUser?.firstName} ${currentUser?.lastName}`
          : '',
        firstName: currentUser?.firstName,
        lastName: currentUser?.lastName,
      }}
    />
  );
};
